import React from "react";
import "./PodiatryMenu.scss";

interface PodiatryMenuProps {
    routinePodiatryUrl?: string;
}

const PodiatryMenu = ({
    routinePodiatryUrl = "https://podiatryplan.my.site.com/provider/locationFinder",
}: PodiatryMenuProps) => {
    return (
        <section className="podiatry-menu">
            <div className="podiatry-menu__notice">
                <p>
                    Benefits vary by plan. Please refer to your Evidence
                    of Coverage (EOC) for benefit details and to determine whether your
                    plan includes additional supplemental services.
                </p>
                <p>
                    If you need assistance, call ACCESS on-Demand Concierge at
                    <a href="tel:18332422223"> 1-833-242-2223 </a>
                    (TTY:711), 24 hours a day, seven days a week.
                </p>
            </div>

            <p className="podiatry-menu__text">
                Eligible Alignment Health Plan members have access to Medicare covered
                and/or routine podiatry benefits. Coverage varies by plan and members
                should refer to their Evidence of Coverage (EOC) for plan specific
                information.
            </p>

            <p className="podiatry-menu__text">
                If you need assistance, please contact the ACCESS On-Demand Concierge at
                <a href="tel:18332422223"> 1-833-242-2223 </a>
                (TTY: 711), available 24 hours a day, 7 days a week.
            </p>

            <h3 className="podiatry-menu__heading">North Carolina Plan Notice:</h3>

            <p className="podiatry-menu__text">
                Eligible members in North Carolina can access the Alignment Health Plan
                network for routine services. To find an in-network Alignment Health
                Plan provider in North Carolina, click on the &ldquo;Doctors&rdquo; button
                above (located on the far left) and search the doctor type you are
                requesting.
            </p>

            <h3 className="podiatry-menu__heading">Medicare Covered</h3>

            <p className="podiatry-menu__text">
                To find an in-network provider, click on the &ldquo;Doctors&rdquo; button
                above (located on the far left) and search the doctor type you are
                requesting.
            </p>

            <h3 className="podiatry-menu__heading">Routine Services</h3>

            <p className="podiatry-menu__text">
                Routine podiatry services are provided through Podiatry Plan. To find
                an in-network provider for routine services, click the button below to
                be redirected to the Podiatry Plan provider search.
            </p>

            <a
                className="podiatry-menu__cta"
                href={routinePodiatryUrl}
                target="_blank"
                rel="noreferrer"
            >
                Find a Podiatrist from the Podiatry Plan Network
            </a>
        </section>
    );
};

export default PodiatryMenu;